import { store } from '../admin-store.js';

let isOpen = false;
let _globalClickBound = false;

export function renderNotificationBell() {
    const d = store.dashboardData || {};
    const count = (d.failed_payments || 0) + (d.expiring_trials || 0) + (d.new_today || 0);

    return `
        <div class="notification-wrapper" id="notifWrapper">
            <button class="btn btn--ghost btn--sm notification-bell" id="notifBell" aria-label="Уведомления">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"/></svg>
                ${count > 0 ? `<span class="notification-badge">${count > 9 ? '9+' : count}</span>` : ''}
            </button>
            <div class="notification-dropdown" id="notifDropdown" style="display:none">
                ${renderNotifItems(d)}
            </div>
        </div>`;
}

function renderNotifItems(d) {
    const items = [];

    if (d.failed_payments > 0) {
        items.push({ icon: '⚠️', text: `${d.failed_payments} неуспешных платежей`, href: '#/billing', cls: 'danger' });
    }
    if (d.expiring_trials > 0) {
        items.push({ icon: '🔔', text: `${d.expiring_trials} триалов истекает`, href: '#/accounts?status=trial', cls: 'warning' });
    }
    if (d.suspended_accounts > 0) {
        items.push({ icon: '🚫', text: `${d.suspended_accounts} заблокированных`, href: '#/accounts?status=suspended', cls: 'danger' });
    }
    if (d.new_today > 0) {
        items.push({ icon: '🆕', text: `${d.new_today} новых сегодня`, href: '#/accounts', cls: 'info' });
    }
    if (d.new_this_week > 5) {
        items.push({ icon: '📈', text: `${d.new_this_week} за неделю`, href: '#/stats', cls: 'success' });
    }

    if (!items.length) {
        return '<div class="notif-empty">Нет уведомлений</div>';
    }

    return `<div class="notif-header">Уведомления</div>` + items.map(i => `
        <a href="${i.href}" class="notif-item notif-item--${i.cls}">
            <span class="notif-item-icon">${i.icon}</span>
            <span class="notif-item-text">${i.text}</span>
            <svg class="notif-item-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
        </a>
    `).join('');
}

export function bindNotifications() {
    const bell = document.getElementById('notifBell');
    const dropdown = document.getElementById('notifDropdown');
    if (!bell || !dropdown) return;

    bell.addEventListener('click', (e) => {
        e.stopPropagation();
        isOpen = !isOpen;
        dropdown.style.display = isOpen ? 'block' : 'none';
    });

    if (!_globalClickBound) {
        _globalClickBound = true;
        document.addEventListener('click', () => {
            if (isOpen) {
                isOpen = false;
                const dd = document.getElementById('notifDropdown');
                if (dd) dd.style.display = 'none';
            }
        });
    }

    dropdown.addEventListener('click', () => {
        isOpen = false;
        dropdown.style.display = 'none';
    });
}
